module.exports = __webpack_public_path__ + "img/security-audit-img-3.1d0aa14b.webp";